/**
 * LDM · Oferta por cantidad
 * ---------------------------------------------------------------------------
 * Sincroniza el tier seleccionado con:
 *   - los inputs `id` y `quantity` del form de producto
 *   - la line item property `_bundle` (para etiquetar el pedido)
 *   - el texto del botón de compra
 *   - la barra de compra persistente, vía el evento `ldm:tier-change`
 *
 * No calcula descuentos. Con packs nativos cada tier vende su variante de
 * cantidad (`data-variant-id`, cantidad 1) y el precio sale de la variante.
 * Sin ellos, agrega `data-qty` unidades de la variante actual.
 *
 * `data-qty` son las unidades que ve el cliente (regalo, barra fija);
 * `data-add-qty` es lo que viaja al carrito.
 *
 * Nota: los tiers son <label> que envuelven un radio. Escuchamos `change` del
 * radio y no `click` del label — asignar `checked` por código dentro de un
 * label dispara un click sintético que reentraría en esta misma función.
 */
(function () {
  'use strict';

  function initOffer(root) {
    if (root.dataset.ldmInit === 'true') return;
    root.dataset.ldmInit = 'true';

    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-ldm-tier]'));
    var form = root.querySelector('form');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var qtyInput = root.querySelector('[data-ldm-qty-input]');
    var bundleInput = root.querySelector('[data-ldm-bundle-input]');
    var savingsInput = root.querySelector('[data-ldm-savings-input]');
    var ctaText = root.querySelector('[data-ldm-cta-text]');
    var baseLabel = ctaText ? ctaText.textContent.trim() : '';

    if (!tiers.length || !qtyInput) return;

    /* Vuelca en el form la variante y la cantidad que agrega el tier. */
    function cargarEnForm(tier) {
      qtyInput.value = cantidadAgregar(tier);
      if (idInput && tier.dataset.variantId) idInput.value = tier.dataset.variantId;
      if (bundleInput) bundleInput.value = tier.dataset.bundleLabel || '';
      // Sin ahorro (1 unidad) el campo va deshabilitado para no enviar una
      // propiedad vacía.
      if (savingsInput) {
        savingsInput.value = tier.dataset.savings || '';
        savingsInput.disabled = !savingsInput.value;
      }
    }

    function apply(tier) {
      if (!tier) return;

      tiers.forEach(function (t) {
        t.classList.toggle('is-selected', t === tier);
      });

      var qty = parseInt(tier.dataset.qty, 10) || 1;
      var price = tier.dataset.priceDisplay || '';
      var bundle = tier.dataset.bundleLabel || '';

      cargarEnForm(tier);
      if (ctaText && price) ctaText.textContent = baseLabel + ' — ' + price;

      actualizarRegalo(root, qty);

      document.dispatchEvent(
        new CustomEvent('ldm:tier-change', {
          detail: { quantity: qty, price: price, label: bundle }
        })
      );
    }

    tiers.forEach(function (tier) {
      var radio = tier.querySelector('.ldm-qo__radio-native');
      if (!radio) return;
      radio.addEventListener('change', function () {
        if (radio.checked) apply(tier);
      });
    });

    // Estado inicial: el tier que el schema dejó preseleccionado.
    var start =
      tiers.filter(function (t) {
        var r = t.querySelector('.ldm-qo__radio-native');
        return r && r.checked;
      })[0] ||
      root.querySelector('[data-ldm-tier].is-selected') ||
      tiers[0];

    apply(start);

    /**
     * Blindaje ante apps de bundles.
     *
     * Kaching (y otras apps del mismo tipo) detectan cualquier form de producto
     * e inyectan sus propios campos, sobrescribiendo `quantity`. Reafirmamos
     * nuestro valor justo antes de enviar y retiramos los campos ajenos, para
     * que la cantidad que se agrega sea siempre la que el usuario eligió.
     */
    if (form) {
      form.addEventListener(
        'submit',
        function () {
          var selected =
            root.querySelector('[data-ldm-tier].is-selected') || start;
          if (selected) cargarEnForm(selected);
          form
            .querySelectorAll('input[name^="properties[__kaching"]')
            .forEach(function (el) {
              el.parentNode.removeChild(el);
            });
        },
        true
      );

      compraDirecta(root, form, function () {
        return root.querySelector('[data-ldm-tier].is-selected') || start;
      });
    }
  }

  /**
   * Compra directa: agrega y lleva al pago en un paso.
   *
   * Se agrega por `fetch` en vez de enviar el formulario porque el envío normal
   * termina en el carrito, y aquí el sentido es saltárselo. Se arma el cuerpo a
   * mano con la variante y la cantidad del tier elegido, de modo que los campos
   * que las apps de bundles inyectan en el formulario no viajen.
   */
  function compraDirecta(root, form, tierActual) {
    var boton = root.querySelector('[data-ldm-buy-now]');
    if (!boton) return;

    var textoEl = boton.querySelector('[data-ldm-buy-now-text]');
    var textoBase = textoEl ? textoEl.textContent.trim() : '';
    var enCurso = false;

    boton.addEventListener('click', function () {
      if (enCurso) return;

      var tier = tierActual();
      var variante = form.querySelector('input[name="id"]');
      var varianteId = (tier && tier.dataset.variantId) || (variante && variante.value);
      if (!varianteId) return;

      var qty = tier ? cantidadAgregar(tier) : 1;
      var props = {};
      if (tier && tier.dataset.bundleLabel) props._bundle = tier.dataset.bundleLabel;
      if (tier && tier.dataset.savings) props.Descuento = tier.dataset.savings;

      enCurso = true;
      boton.disabled = true;
      if (textoEl) textoEl.textContent = 'Un momento…';

      fetch(window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(varianteId), quantity: qty, properties: props }]
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('No se pudo agregar');
          window.location.href = '/checkout';
        })
        .catch(function () {
          // Si falla, se devuelve el control en lugar de dejar el botón colgado.
          enCurso = false;
          boton.disabled = false;
          if (textoEl) textoEl.textContent = textoBase;
        });
    });
  }

  /* Con pack nativo se agrega 1 de la variante del pack; sin él, las unidades. */
  function cantidadAgregar(tier) {
    return (
      parseInt(tier.dataset.addQty, 10) ||
      parseInt(tier.dataset.qty, 10) ||
      1
    );
  }

  /**
   * Estado del regalo por volumen.
   *
   * Mientras la cantidad elegida no llega al mínimo, el aviso dice cuánto falta
   * y se ve apagado; al alcanzarlo cambia el texto, se marca en verde y el icono
   * pasa de caja a check con un rebote breve. Sin esto el mismo mensaje aparecía
   * con 1 unidad que con 3 y no se entendía que el regalo se activaba.
   */
  function actualizarRegalo(root, qty) {
    var gift = root.querySelector('[data-ldm-gift]');
    if (!gift) return;

    var min = parseInt(gift.dataset.giftMin, 10) || 2;
    var textoEl = gift.querySelector('[data-ldm-gift-text]');
    var desbloqueado = qty >= min;
    var yaEstaba = gift.classList.contains('is-unlocked');

    if (textoEl) {
      var txt = desbloqueado ? gift.dataset.giftUnlocked : gift.dataset.giftLocked;
      if (!desbloqueado && txt) {
        var faltan = min - qty;
        txt = txt.replace('{n}', faltan);
      }
      if (txt) textoEl.textContent = txt;
    }

    gift.classList.toggle('is-unlocked', desbloqueado);

    // El rebote solo en la transición de bloqueado a desbloqueado, no en cada
    // repintado: repetirlo en cada clic resultaría ruidoso.
    if (desbloqueado && !yaEstaba) {
      gift.classList.remove('ldm-celebra');
      void gift.offsetWidth;
      gift.classList.add('ldm-celebra');
    }
  }

  function initAll() {
    document.querySelectorAll('[data-ldm-quantity-offer]').forEach(initOffer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // El editor de temas reinyecta secciones sin recargar la página.
  document.addEventListener('shopify:section:load', initAll);
})();
